import { Project } from '../models/project.model';

export const PROJECTS: Project[] = [
  {
    id: '1',
    slug: 'project-01',
    title: 'Project 01',

    previewImage: '/projects/1.png',

    backgroundColor: '#000000',
    textColor: '#ffffff',

    sections: [
      { image: '/projects/project-01/1.png' },
      { image: '/projects/project-01/2.png' },
      { image: '/projects/project-01/3.png' }
    ],

    overview: {
      description: [
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ea amet amet incididunt deserunt sit nostrud laborum occaecat exercitation ea id occaecat deserunt consequat.',
        'Pariatur nisi ad ex sunt velit dolor nulla excepteur sunt nostrud sunt ex reprehenderit ut. Et nostrud labore sint nostrud sunt officia quis officia voluptate incididunt.'
      ],
      items: [
        { label: 'Client', values: ['First Class Solutions Ltd'] },
        { label: 'Site', values: ['ilovefirstclass.com'] },
        { label: 'Year', values: ['2026'] },
        { label: 'Stack', values: ['Name', 'Name', 'Name'] },
        { label: 'Team', values: ['Name Surname', 'Name Surname'] },
        { label: 'Scope', values: ['Travel Tech'] }
      ]
    }
  },
  {
    id: '2',
    slug: 'project-02',
    title: 'Project 02',

    previewImage: '/projects/2.png',

    backgroundColor: '#000000',
    textColor: '#ffffff',

    sections: [
      { image: '/projects/project-02/1.png' },
      { image: '/projects/project-02/2.png' }
    ],

    overview: {
      description: [
        'Mock overview text for Project 02.',
        'Second paragraph for Project 02.'
      ],
      items: [
        { label: 'Client', values: ['Client 02'] },
        { label: 'Site', values: ['project02.com'] },
        { label: 'Year', values: ['2025'] },
        { label: 'Stack', values: ['Angular', 'Figma'] },
        { label: 'Team', values: ['Name Surname'] },
        { label: 'Scope', values: ['UX/UI Design'] }
      ]
    }
  },
  {
    id: '3',
    slug: 'project-03',
    title: 'Project 03',

    previewImage: '/projects/3.png',

    backgroundColor: '#000000',
    textColor: '#ffffff',

    sections: [
      { image: '/projects/project-03/1.png' },
      { image: '/projects/project-03/2.png' },
      { image: '/projects/project-03/3.png' }
    ],

    overview: {
      description: [
        'Mock overview text for Project 03.',
        'Second paragraph for Project 03.'
      ],
      items: [
        { label: 'Client', values: ['Client 03'] },
        { label: 'Site', values: ['project03.com'] },
        { label: 'Year', values: ['2024'] },
        { label: 'Stack', values: ['Name', 'Name'] },
        { label: 'Team', values: ['Name Surname', 'Name Surname'] },
        { label: 'Scope', values: ['Product Design'] }
      ]
    }
  }
];
